// extracted by mini-css-extract-plugin
export default {"about":"about_about__pmZN4","me":"about_me__-0vQD","aboutContainer":"about_aboutContainer__qeZDj","mobMe":"about_mobMe__QoHcP"};